import React from 'react';
import { TextField as MTextField } from '@material-ui/core';
import useStyles, { useLabelStyles } from './styles';

function TextField({ InputLabelProps, InputProps, ...props }) {
    const classes = useStyles();
    const labelClasses = useLabelStyles();

    const inputProps = {
        classes,
        fullWidth: true,
        ...InputProps,
    };

    const inputLabelProps = {
        shrink: true,
        classes: labelClasses,
        ...InputLabelProps,
    };

    return (
        <MTextField
            {...props}
            InputProps={inputProps}
            InputLabelProps={inputLabelProps}
        />
    );
}

export default TextField;
